import { FC, ReactElement } from 'react'
import { ComingSoon } from 'src/components/coming-soon'

export const TeacherVideoLessons: FC = (): ReactElement => (
  <>
    <h2 className="sectionHb-title">VideoLessons</h2>
    <ComingSoon />
  </>
)
